import React from 'react'
import { Icon, IconType } from '.'

export type InfoProps = {
  value?: string
  icon: IconType
  color?: 'primary' | 'secondary' | 'white' | 'black' | 'gray' | 'night'
  size?: 'sm' | 'md' | 'lg'
}

const Info: React.FC<InfoProps> = ({
  value = undefined,
  icon,
  color = 'black',
  size = 'md',
}) => {
  let iconSize = ''
  let textSize = ''
  switch (size) {
    case 'md':
      iconSize = 'w-5 h5'
      textSize = 'lg:text-base lg:h-6 text-sm h-5'
      break
    case 'lg':
      iconSize = 'w-6 h-6'
      textSize = 'lg:text-lg lg:h-7 text-base h-6'
      break
    default:
      iconSize = 'w-5 h-5'
      textSize = 'text-sm h-5'
  }

  if (!value) {
    return null
  }

  return (
    <div className="flex flex-row items-center gap-1">
      <Icon icon={icon} color={color} className={iconSize} />
      <div className={`${textSize} leading-6 align-bottom`}>{value}</div>
    </div>
  )
}

export default Info
